import React, { useState, useEffect } from 'react';
import { MessageCircle, ChevronLeft, ChevronRight, Heart } from 'lucide-react';
import { Button } from './ui/button';

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const heroImages = [
  'https://customer-assets.emergentagent.com/job_spa-escape/artifacts/nwr4quc6_2c2646c9-608b-4510-855c-fdc742ba6dd9.jpeg',
  'https://customer-assets.emergentagent.com/job_spa-escape/artifacts/9ix0w8gh_711AA23A-BF8B-4968-B933-4C194A8755E1.jpeg',
  'https://customer-assets.emergentagent.com/job_spa-escape/artifacts/gv0vk8ht_48DFC5D5-48FE-4A07-9D2A-A098FCE5F033.jpeg'];


  const galleryImages = [
  'https://customer-assets.emergentagent.com/job_spa-escape/artifacts/lkblfbo4_IMG_3746.jpeg',
  'https://customer-assets.emergentagent.com/job_spa-escape/artifacts/nwr4quc6_2c2646c9-608b-4510-855c-fdc742ba6dd9.jpeg',
  'https://customer-assets.emergentagent.com/job_spa-escape/artifacts/9ix0w8gh_711AA23A-BF8B-4968-B933-4C194A8755E1.jpeg',
  'https://customer-assets.emergentagent.com/job_spa-escape/artifacts/gv0vk8ht_48DFC5D5-48FE-4A07-9D2A-A098FCE5F033.jpeg'];


  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [heroImages.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroImages.length) % heroImages.length);
  };

  const openWhatsApp = () => {
    const message = encodeURIComponent('Bonjour, je souhaiterais réserver votre LoveRoom pouvez-vous me donner plus d\'informations svp?');
    window.open(`https://wa.me/33758585833?text=${message}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-pink-900 to-rose-900">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-purple-900/90 backdrop-blur-md border-b border-pink-500/30">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <Heart className="w-8 h-8 text-pink-400 fill-pink-400" />
              <h1 className="text-2xl font-bold bg-gradient-to-r from-pink-400 to-rose-400 bg-clip-text text-transparent">
                Loveroom78
              </h1>
            </div>
            <Button
              onClick={openWhatsApp}
              className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white transition-all duration-300 shadow-lg hover:shadow-xl">

              <MessageCircle className="w-4 h-4 mr-2" />
              Réserver
            </Button>
          </div>
        </div>
      </header>

      {/* Hero Section with Carousel */}
      <section className="relative h-screen pt-20">
        <div className="absolute inset-0">
          {heroImages.map((img, index) =>
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'}`
            }>

              <img
              src={img}
              alt={`Loveroom78 - ${index + 1}`}
              className="w-full h-full object-cover" />

              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
            </div>
          )}
        </div>

        {/* Carousel Controls */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-white/20 backdrop-blur-sm hover:bg-white/30 p-3 rounded-full transition-all duration-300">

          <ChevronLeft className="w-6 h-6 text-white" />
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-white/20 backdrop-blur-sm hover:bg-white/30 p-3 rounded-full transition-all duration-300">

          <ChevronRight className="w-6 h-6 text-white" />
        </button>

        {/* Hero Content */}
        <div className="absolute inset-0 flex items-center justify-center z-10">
          <div className="text-center px-4 space-y-6">
            <div className="inline-block animate-fade-in">
              <div className="flex items-center justify-center space-x-3 mb-4">
                <Heart className="w-12 h-12 text-rose-500 fill-rose-500 animate-pulse" />
                <h1 className="text-5xl md:text-7xl font-bold text-white drop-shadow-2xl">
                  Loveroom78
                </h1>
                <Heart className="w-12 h-12 text-rose-500 fill-rose-500 animate-pulse" />
              </div>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white drop-shadow-2xl">
              Vivez une Expérience
            </h2>
            <h3 className="text-3xl md:text-5xl font-bold bg-gradient-to-r from-rose-300 to-pink-300 bg-clip-text text-transparent drop-shadow-2xl">
              Romantique & Privative
            </h3>
            <p className="text-xl md:text-2xl text-white/90 drop-shadow-lg">
              Jacuzzi 100% Privatif au cœur des Mureaux (78)
            </p>
            <Button
              onClick={openWhatsApp}
              size="lg"
              className="bg-gradient-to-r from-rose-500 to-pink-600 hover:from-rose-600 hover:to-pink-700 text-white text-lg px-8 py-6 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300">

              <MessageCircle className="w-5 h-5 mr-2" />
              Réserver Maintenant
            </Button>
          </div>
        </div>

        {/* Carousel Indicators */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex space-x-2">
          {heroImages.map((_, index) =>
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
            index === currentSlide ?
            'bg-rose-500 w-8' :
            'bg-white/50 hover:bg-white/70'}`
            } />

          )}
        </div>
      </section>

      {/* About Section */}
      <section className="py-20 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="bg-purple-800/40 backdrop-blur-sm rounded-3xl shadow-2xl p-8 md:p-12 border border-pink-500/30">
            <div className="text-center mb-8">
              <Heart className="w-16 h-16 text-pink-400 fill-pink-400 mx-auto mb-4" />
              <h2 className="text-4xl font-bold bg-gradient-to-r from-pink-400 to-rose-400 bg-clip-text text-transparent mb-4">
                Une Expérience Unique
              </h2>
            </div>
            <p className="text-lg text-white/90 leading-relaxed mb-6">
              Bienvenue à <span className="font-semibold text-pink-400">Loveroom78</span>, situé aux Mureaux (78) dans un endroit calme et discret avec parking privé. Notre spa est chauffé à 40° toute l'année et dispose d'un sauna. 
              Découvrez un espace entièrement privatif où le luxe rencontre la sérénité.
            </p>
            <p className="text-lg text-white/90 leading-relaxed">
              Que ce soit pour célébrer une occasion spéciale, vous ressourcer en couple ou entre amis, 
              notre love room offre un cadre exceptionnel avec jacuzzi privatif et une ambiance 
              soigneusement créée pour vos moments inoubliables.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mt-12">
              <div className="text-center p-6 bg-purple-700/40 rounded-2xl border border-pink-500/30">
                <div className="w-16 h-16 bg-gradient-to-r from-pink-500 to-rose-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Heart className="w-8 h-8 text-white fill-white" />
                </div>
                <h3 className="text-xl font-bold text-pink-400 mb-2">Confort Premium</h3>
                <p className="text-white/80">Équipements haut de gamme pour votre bien-être</p>
              </div>

              <div className="text-center p-6 bg-purple-700/40 rounded-2xl border border-pink-500/30">
                <div className="w-16 h-16 bg-gradient-to-r from-pink-500 to-rose-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Heart className="w-8 h-8 text-white fill-white" />
                </div>
                <h3 className="text-xl font-bold text-pink-400 mb-2">100% Privatif</h3>
                <p className="text-white/80">Votre espace exclusif en toute intimité</p>
              </div>

              <div className="text-center p-6 bg-purple-700/40 rounded-2xl border border-pink-500/30">
                <div className="w-16 h-16 bg-gradient-to-r from-pink-500 to-rose-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Heart className="w-8 h-8 text-white fill-white" />
                </div>
                <h3 className="text-xl font-bold text-pink-400 mb-2">Disponible 7j/7</h3>
                <p className="text-white/80">Réservez quand vous le souhaitez</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-20 px-4 bg-purple-950/50">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold bg-gradient-to-r from-pink-400 to-rose-400 bg-clip-text text-transparent mb-4">
              Galerie Photos
            </h2>
            <p className="text-lg text-white/80">Découvrez l'ambiance romantique de Loveroom78</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {galleryImages.map((img, index) =>
            <div
              key={index}
              className="group relative aspect-square overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105">

                <img
                src={img}
                alt={`Loveroom78 - Photo ${index + 1}`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />

                <div className="absolute inset-0 bg-gradient-to-t from-purple-900/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-20 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="bg-gradient-to-br from-pink-600 to-rose-600 rounded-3xl shadow-2xl p-8 md:p-12 text-center text-white">
            <Heart className="w-16 h-16 fill-white mx-auto mb-6" />
            <h2 className="text-4xl font-bold mb-4">Contactez-Nous</h2>
            <p className="text-xl mb-6 text-white/90">
              Les Mureaux (78)
            </p>
            <p className="text-2xl font-bold mb-8">
              <a href="tel:0758585833" className="hover:text-rose-100 transition-colors duration-300">
                07 58 58 58 33
              </a>
            </p>
            <Button
              onClick={openWhatsApp}
              size="lg"
              className="bg-white text-pink-600 hover:bg-pink-50 text-lg px-8 py-6 rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300">

              <MessageCircle className="w-5 h-5 mr-2" />
              Réserver sur WhatsApp
            </Button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-purple-950 to-pink-950 text-white py-12 px-4">
        <div className="container mx-auto max-w-4xl">
          {/* Logo et Nom */}
          <div className="text-center mb-8">
            <div className="flex items-center justify-center space-x-2 mb-4">
              <Heart className="w-6 h-6 fill-white" />
              <p className="text-xl font-bold">Loveroom78</p>
            </div>
            <p className="text-white/80">© 2025 Loveroom78 - Tous droits réservés</p>
            <p className="text-white/70 mt-2">Jacuzzi Privatif - Les Mureaux (78)</p>
          </div>

          {/* Section RGPD et Confidentialité */}
          <div className="border-t border-white/20 pt-8">
            <div className="bg-purple-900/40 rounded-2xl p-6 backdrop-blur-sm border border-pink-500/20">
              <h3 className="text-lg font-bold text-pink-400 mb-4 text-center">
                Protection des Données Personnelles
              </h3>
              <div className="text-white/90 text-sm space-y-3 text-left max-w-3xl mx-auto">
                <p>
                  L'entreprise respecte les obligations du <span className="font-semibold text-pink-300">Règlement Général sur la Protection des Données (RGPD)</span>.
                </p>
                <p>
                  Les informations personnelles des clients (nom, e-mail, téléphone) sont collectées uniquement pour la gestion des réservations et la communication nécessaire à la prestation du service.
                </p>
                <p>
                  Ces données sont stockées de manière sécurisée et ne sont jamais partagées avec des tiers.
                </p>
                <p>
                  Les clients peuvent à tout moment demander la modification ou la suppression de leurs informations.
                </p>
                <p className="text-center mt-4">
                  <a
                    href="tel:0758585833"
                    className="text-pink-400 hover:text-pink-300 underline transition-colors duration-300">

                    Contactez-nous pour toute demande concernant vos données personnelles
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp Button */}
      <button
        onClick={openWhatsApp}
        className="fixed bottom-8 right-8 z-50 bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-300 animate-bounce"
        aria-label="Contacter sur WhatsApp">

        <MessageCircle className="w-6 h-6" />
      </button>
    </div>);

};

export default Home;